export default {

  Utility: {
    roundUpIfNotInteger(totalRows, perPage) {

      let result = totalRows / perPage

      if (Number.isInteger(result)) {
      
        return result
      
      } 
      else {
      
        return Math.ceil(result)
      }
    }
  }
}